// Maps native permission/status strings to a theme color for the debug drawer.
const OK_STATUSES = ["authorized", "granted", "readConfirmed"];
const BAD_STATUSES = ["denied", "sharingDenied", "timedOut", "answeredNoData"];

export const statusColor = (status: string) => {
  if (OK_STATUSES.includes(status)) {
    return "success.main";
  }
  if (BAD_STATUSES.includes(status)) {
    return "error.main";
  }
  return "text.secondary";
};
